// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"4":"banner-lazy","40":"cookie-policy"}[chunkId] || chunkId) + ".lite.js?ver=" + {"4":"c09e96ea727591af","40":"a002ed55a2cd8984","227":"eb91502fb5aa9e2c","343":"a12327ef46b2b83a"}[chunkId] + "";
};